export const NOTHING = '';
/**
   * Permet de supprimer un element du tableau
   * passé en paramètre
   * @param {Array<string>} columns tableau
   * @param {string} value valeur à supprimer
   * @returns {void}
   */
export function columnsSplice(columns, value) {
  const index = columns.findIndex(column => column === value);
  if (index !== -1) columns.splice(index, 1);
}
